import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "19",
      height: "19",
      x: ".5",
      y: ".5",
      fill: "currentColor",
      rx: "9.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "19",
      height: "19",
      x: ".5",
      y: ".5",
      stroke: "currentColor",
      rx: "9.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "8",
      height: "8",
      x: "6",
      y: "6",
      fill: "#fff",
      rx: "4"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "checkbox"}) } }